module.exports = __webpack_public_path__ + "img/profile_box_age_range.d73686cf.svg";